import { API_URL } from '../config/index';
import axios from 'axios';

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'devicetype': 'GOTablet'
  },
});

const file = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
    'devicetype': 'GOTablet'
  },
});

const updateSettings = async (id, data) => {
  const res = await file.put(`/settings/${id}`, data);
  return res;
};
const updateGeneralSettings = async (id, data) => {
  const res = await file.put(`/settings/general/${id}`, data);
  return res;
};
const deleteLogo = async (userId, logotype) => {
  const res = await instance.delete(`/settings/deleteLogo/${userId}`, { headers: { 'devicetype': 'GOTablet', 'logotype': logotype}});
  return res;
};
const getSettings = async (data) => {
  const res = await instance.get('/settings', {
    params: data,
  });
  return res;
};
const addAds = async (userId, data) => {
  const res = await file.post(`/settings/addAds/${userId}`, data, { headers: { 'devicetype': 'GOTablet'}});
  return res;
};
const deleteAds = async (userId, data) => {
  const res = await instance.delete(`/settings/deleteAds/${userId}`, { headers: { 'devicetype': 'GOTablet'}, data});
  return res;
};
const defaultTheme = async (userId) => {
  const res = await instance.put(`/settings/${userId}/restoreTheme`, { headers: { 'devicetype': 'GOTablet'}});
  return res;
};

export {
  updateSettings,
  getSettings,
  addAds,
  deleteAds,
  updateGeneralSettings,
  deleteLogo,
  defaultTheme,
};
